<template>
  <div class="container-fluid">
    <div class="card">
      <div class="card-body">
        <ul class="nav nav-tabs" id="accessTabs" role="tablist">
          <li class="nav-item" role="presentation">
            <button
              class="nav-link active"
              id="tab-charts-tab"
              data-bs-toggle="tab"
              data-bs-target="#tab-charts"
              type="button"
              role="tab"
              aria-controls="tab-charts"
              aria-selected="true"
            >
              Gráficos
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="tab-log-access-tab"
              data-bs-toggle="tab"
              data-bs-target="#tab-log-access"
              type="button"
              role="tab"
              aria-controls="tab-log-access"
              aria-selected="false"
            >
              Logs de rotas
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="tab-analytic-logs-tab"
              data-bs-toggle="tab"
              data-bs-target="#tab-analytic-logs"
              type="button"
              role="tab"
              aria-controls="tab-analytic-logs"
              aria-selected="false"
            >
              Analytics de telas
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="tab-customer-change-tab"
              data-bs-toggle="tab"
              data-bs-target="#tab-customer-change"
              type="button"
              role="tab"
              aria-controls="tab-customer-change"
              aria-selected="false"
            >
              Trocas de cliente
            </button>
          </li>
        </ul>

        <div class="tab-content mt-3" id="accessTabsContent">
          <div
            class="tab-pane fade show active"
            id="tab-charts"
            role="tabpanel"
            aria-labelledby="tab-charts-tab"
          >
            <div class="row">
              <div class="col-md-12">
                <access-on-time></access-on-time>
              </div>
              <div class="col-md-12">
                <hr />
                <access-on-time-by-screen></access-on-time-by-screen>
              </div>
              <div class="col-md-12">
                <hr />
                <access-on-time-by-customer></access-on-time-by-customer>
              </div>
            </div>
          </div>

          <div
            class="tab-pane fade"
            id="tab-log-access"
            role="tabpanel"
            aria-labelledby="tab-log-access-tab"
          >
            <log-access-list></log-access-list>
          </div>

          <div
            class="tab-pane fade"
            id="tab-analytic-logs"
            role="tabpanel"
            aria-labelledby="tab-analytic-logs-tab"
          >
            <analytic-log-list></analytic-log-list>
          </div>

          <div
            class="tab-pane fade"
            id="tab-customer-change"
            role="tabpanel"
            aria-labelledby="tab-customer-change-tab"
          >
            <customer-change-log-list></customer-change-log-list>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccessOnTime from "./AccessOnTime.vue";
import AccessOnTimeByScreen from "./AccessOnTimeByScreen.vue";
import AccessOnTimeByCustomer from "./AccessOnTimeByCustomer.vue";
import CustomerChangeLogList from "./CustomerChangeLogList.vue";
import LogAccessList from "./LogAccessList.vue";
import AnalyticLogList from "./AnalyticLogList.vue";

export default {
  components: {
    AccessOnTime,
    AccessOnTimeByScreen,
    AccessOnTimeByCustomer,
    CustomerChangeLogList,
    LogAccessList,
    AnalyticLogList,
  },
};
</script>
